<script setup>
import { onMounted, computed } from 'vue';
import { useMenuStore } from '@/stores/menuStore';
import { storeToRefs } from 'pinia';

const props = defineProps({
  errorMessage: {
    type: String,
    default: '',
  },
  // This prop can be used to apply custom CSS classes for badge placement
  badgeClass: {
    type: String,
    default: '',
  },
});

const menuStore = useMenuStore();
const { footerItems } = storeToRefs(menuStore);

const privacyPolicyLink = computed(() => {
  const item = footerItems.value.find(item => Number(item.id) === 3);
  return item ? item.path : 'https://policies.google.com/privacy';
});

const termsOfServiceLink = computed(() => {
  const item = footerItems.value.find(item => Number(item.id) === 158);
  return item ? item.path : 'https://policies.google.com/terms';
});

</script>

<template>
  <div class="recaptcha-container">
    <p v-if="errorMessage" class="recaptcha-error-message">{{ errorMessage }}</p>
    <div :class="['recaptcha-badge-placeholder', badgeClass]">
      <!-- The reCAPTCHA badge will typically appear here, injected by Google's script -->
      <!-- Its position is usually controlled by CSS on the .grecaptcha-badge class -->
    </div>
    <p class="recaptcha-notice">
      Ce site est protégé par reCAPTCHA et les
      <a :href="privacyPolicyLink" target="_blank">Règles de confidentialité</a> et les
      <a :href="termsOfServiceLink" target="_blank">Conditions d'utilisation</a> s'appliquent.
    </p>
  </div>
</template>

<style scoped>
.recaptcha-container {
  text-align: center;
  margin-top: 1.5rem;
}

.recaptcha-error-message {
  color: #d9534f;
  background-color: #f2dede;
  padding: 0.5rem;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.recaptcha-badge-placeholder {
  /* This is a placeholder. The actual reCAPTCHA badge is a fixed element */
  /* You can add styles here if you want to visually represent where the badge might be */
  /* For example: border: 1px dashed #ccc; height: 50px; */
}

.recaptcha-notice {
  font-size: 0.8rem;
  color: #666;
}

.recaptcha-notice a {
  color: #007bff;
  text-decoration: none;
}

.recaptcha-notice a:hover {
  text-decoration: underline;
}
</style>
